import type {FunctionComponent, HTMLAttributes} from 'react'
import React from 'react'
import {DiscountRibbon} from '~/icons/home-page/discoun-ribbon-corner'

interface DiscountCornerBadgeProps extends HTMLAttributes<HTMLDivElement> {
  content: string
}

const DiscountCornerRibbon: FunctionComponent<DiscountCornerBadgeProps> = ({content, ...attributes}) => {
  return (
    <div {...attributes}>
      <div className="relative">
        <DiscountRibbon className="ribbon" text={content} />
      </div>
    </div>
  )
}

export default DiscountCornerRibbon
